module.exports = __webpack_public_path__ + "static/media/21-9.86de9d18.mp3";